export default [
  '😃',
  '😬',
  '😂',
  '😅',
  '😆',
  '😍',
  '😱',
  '👋',
  '👏',
  '👍',
  '🙌',
  '👌',
  '🙏',
  '👻',
  '🍔',
  '🍑',
  '🍆',
  '🔑',
];



// WEBPACK FOOTER //
// ./src/arkulpa-fec/components/ArkEdit/emojies.js